import { type ConfirmOptions, useConfirmModalStore } from '@client/stores/confirmModalStore';

export { ConfirmModal } from './ConfirmModal';
export type { ConfirmOptions };

/**
 * Show a confirmation modal with custom ButtonModern buttons.
 *
 * @example
 * import { confirm } from '@client/components/_ui/feedback/confirm-modal';
 *
 * confirm({
 *   title: 'Delete Item',
 *   content: 'Are you sure you want to delete this item?',
 *   okText: 'Delete',
 *   okDanger: true,
 *   onOk: async () => {
 *     await deleteItem();
 *   },
 * });
 */
export function confirm(options: ConfirmOptions): void {
    useConfirmModalStore.getState().show(options);
}
